import React, { useContext, useEffect, useState } from 'react';
import { Context } from '../Context/Context';

// import Search from '../Components/Images/search-lg.svg';
// import Bell from '../Components/Images/bell-01.svg';
import Add from '../Components/Images/AddBtn.svg';
import refresh from '../Components/Images/refresh.svg'
import warn from '../Components/Images/Warn.svg'
import close from '../Components/Images/close.png'

import CreateInvoiceBar from './CreateInvoiceBar';
import CreatedInvoices from './CreatedInvoices';
import DeleteInvoice from './DeleteInvoice';
import { useLocation, useNavigate } from 'react-router-dom';
import ViewInvoiceBar from './ViewInvoiceBar';
// import DeleteInvoiceModal from './DeleteInvoiceModal';

const CreateInvoice = ({ NumberOfInvoices, verified, contentRef, getInvoice, UserInvoice, loadingInvoice }) => {
    const {
        handleCreateInvoice,
        handleViewInvoice,
        createInvoice,
        viewInvoice,
        // showModal,
        // setShowModal
    } = useContext(Context);
    const location = useLocation()
    const navigate = useNavigate()


    const [deleteInvoiceBar, setDeleteInvoiceBar] = useState(false);
    const [deleteInvoiceErrorBar, setDeleteInvoiceErrorBar] = useState(false);
    const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
    const [invoiceErrorModal, setInvoiceErrorModal] = useState(false);

    useEffect(() => {
        if (deleteInvoiceBar) {
            setTimeout(() => {
                setDeleteInvoiceBar(false)
            }, 4200);
        }
        if (deleteInvoiceErrorBar) {
            setTimeout(() => {
                setDeleteInvoiceErrorBar(false)
            }, 5200);
        }
        if (openInvoiceModal) {
            setTimeout(() => {
                setOpenInvoiceModal(false)
            }, 4200);
        }
        if (invoiceErrorModal) {
            setTimeout(() => {
                setInvoiceErrorModal(false)
            }, 5200);
        }
    }, [deleteInvoiceBar, deleteInvoiceErrorBar, openInvoiceModal, invoiceErrorModal])

    const isVerified = () => {
        if (!verified) {
            navigate('/dashboard', {
                replace: true,
                state: {
                    error: 'You need to fill in your KYC data to continue',
                    from: location.pathname,
                },
            });
            return;
        }

        handleCreateInvoice();
    };

    return (
        <div>
            <div
                className={`w-full top-0 h-[200%] z-30 absolute ${createInvoice || viewInvoice ? 'bg-black/20' : 'hidden'
                    }`}
                onClick={
                    createInvoice
                        ? handleCreateInvoice
                        : viewInvoice
                            ? handleViewInvoice
                            : null
                }
            ></div>

            <div className="md:p-10 py-10 px-4">
                <div className='flex justify-between items-center mb-2 sp:mb-0'>
                    <div className="flex items-center gap-2">
                        <p className="text-[28px] font-semibold">Invoices</p>
                    </div>
                    <div className="flex md:items-center items-start gap-9">
                        <img
                            src={refresh}
                            alt=""
                            onClick={getInvoice}
                            className='cursor-pointer'
                        />
                        {/* <img className="lg:block hidden cursor-pointer" src={Search} alt="" />
                        <img className="lg:block hidden cursor-pointer" src={Bell} alt="" /> */}
                        <img className="w-10 cursor-pointer" onClick={handleCreateInvoice} src={Add} alt="" />
                    </div>
                </div>
                <p className="text-[16px] font-normal pr-10 text-[#525154]">
                    View and manage your created and sent invoices here.
                </p>
            </div>

            {loadingInvoice ? (
                <div className="flex justify-center items-center h-[20vh]">
                    <p className="text-lg font-medium text-[#531CB3]">Loading Invoices...</p>
                </div>
            ) : NumberOfInvoices > 0 ? (
                <>
                    <CreatedInvoices UserInvoice={UserInvoice} />
                    <DeleteInvoice
                        setDeleteInvoiceBar={setDeleteInvoiceBar}
                        nsetDeleteInvoiceErrorBar={setDeleteInvoiceErrorBar}
                    />
                    <ViewInvoiceBar contentRef={contentRef} />
                    {/* {showModal && (
                        <div onClick={() => setShowModal(false)} className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                            <div className="bg-white rounded-[20px] mx-3 p-6 max-w-sm w-full text-center">
                                <h2 className="text-xl font-bold mb-4">Download Complete</h2>
                                <p className="mb-6">Your invoice has been saved successfully.</p>
                                <button
                                    onClick={() => setShowModal(false)}
                                    className="bg-[#491597] text-white px-4 py-2 rounded-lg"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )} */}

                </>
            ) : (
                <div className="flex flex-col items-center gap-9 bg-[#F9F7FC] lg:mx-10 mx-4 px-2 py-16 rounded-md border-2 border-black/50 border-dashed">
                    <div>
                        <p className="text-center font-medium text-[20px]">Create your first quote!</p>
                        <p className="text-center font-normal mt-1 text-[#525154]">
                            Create and share your invoices to start earning today!
                        </p>
                    </div>
                    <button
                        className="bg-[#531CB3] text-white py-[10px] px-4 rounded-lg"
                        onClick={() => {
                            window.scrollTo(0, 0);
                            isVerified();
                        }}
                    >
                        Create invoice
                    </button>
                </div>
            )}

            <CreateInvoiceBar invoiceErrorModal={invoiceErrorModal} openInvoiceModal={openInvoiceModal} setInvoiceErrorModal={setInvoiceErrorModal} setOpenInvoiceModal={setOpenInvoiceModal} />
            {/* <DeleteInvoiceModal
                deleteInvoiceBar={deleteInvoiceBar}
                setDeleteInvoiceBar={setDeleteInvoiceBar}
                deleteInvoiceErrorBar={deleteInvoiceErrorBar}
                setDeleteInvoiceErrorBar={setDeleteInvoiceErrorBar}
            /> */}

            {openInvoiceModal && (
                <div className='absolute md:top-24 z-50 top-10 sm:right-10 right-2 flex items-center  justify-between p-4 rounded-lg bg-[#1CB353] text-[#F9F7FC]'>
                    <div className='flex gap-2 items-start'>
                        <img className='mt-1' src={warn} alt="" />
                        <div>
                            <p className='text-[14px] text-[#F9F7FC] font-medium'>Invoice added.</p>
                            <p className='text-[14px] text-[#CFF9DE] font-normal'>You've successfully add an invoice.</p>
                        </div>
                        <img
                            onClick={() => setOpenInvoiceModal(false)}
                            className='size-[10px] cursor-pointer'
                            src={close}
                            alt=""
                        />
                    </div>
                </div>
            )}

            {invoiceErrorModal && (
                <div className='absolute md:top-24 z-50 top-10 sm:right-10 right-2 flex items-center  justify-between p-4 rounded-lg bg-[#EF4444] text-[#F9F7FC]'>
                    <div className='flex gap-2 items-start'>
                        <img className='mt-1' src={warn} alt="" />
                        <div>
                            <p className='text-[14px] text-[#F9F7FC] font-medium'>Failed to add invoice.</p>
                            <p className='text-[14px] text-[#CFF9DE] font-normal'>We couldn’t create the invoice at the moment. Please try again later.</p>
                        </div>
                        <img
                            onClick={() => setInvoiceErrorModal(false)}
                            className='size-[10px] cursor-pointer'
                            src={close}
                            alt=""
                        />
                    </div>
                </div>
            )}

            {deleteInvoiceBar && (
                <div className='absolute md:top-24 z-50 top-10 sm:right-10 right-2 flex items-center  justify-between p-4 rounded-lg bg-[#1CB353] text-[#F9F7FC]'>
                    <div className='flex gap-2 items-start'>
                        <img className='mt-1' src={warn} alt="" />
                        <div>
                            <p className='text-[14px] text-[#F9F7FC] font-medium'>Invoice deleted.</p>
                            <p className='text-[14px] text-[#CFF9DE] font-normal'>You've successfully deleted the invoice.</p>
                        </div>
                        <img
                            onClick={() => setDeleteInvoiceBar(false)}
                            className='size-[10px] cursor-pointer'
                            src={close}
                            alt=""
                        />
                    </div>
                </div>
            )}

            {deleteInvoiceErrorBar && (
                <div className='absolute md:top-24 z-50 top-10 sm:right-10 right-2 flex items-center  justify-between p-4 rounded-lg bg-[#EF4444] text-[#F9F7FC]'>
                    <div className='flex gap-2 items-start'>
                        <img className='mt-1' src={warn} alt="" />
                        <div>
                            <p className='text-[14px] text-[#F9F7FC] font-medium'>Failed to delete invoice.</p>
                            <p className='text-[14px] text-[#CFF9DE] font-normal'>We couldn’t delete the invoice at the moment. Please try again later.</p>
                        </div>
                        <img
                            onClick={() => setDeleteInvoiceErrorBar(false)}
                            className='size-[10px] cursor-pointer'
                            src={close}
                            alt=""
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default CreateInvoice;
